export type EmptyArray = Array<never>;
